

























































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator'
import { APICarrier } from '../../models/api/carrier.model'

@Component
export default class ProvidersForm extends Vue {
    loading = true
    data: {[key: string]: unknown} = {}

    cardTitle = ''

    buttonLoading = false

    formData: {[key: string]: any} = {
        providerEnabled: true,
        typeId: {
            id: null
        }
    }

    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        notification: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 255) || 'Field must be less than 255 characters'
        ],
        name: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 128) || 'Field must be less than 128 characters'
        ]
    }

    formModel: { carriers: APICarrier[] } = {
        carriers: []
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }

        await this.getCarriers()

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Provider'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Provider'
            this.data = {}
            this.loading = false
            break
        }
    }

    getCarriers () {
        return new Promise(resolve => {
            this.$store.dispatch('getCarriers')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.carriers = this.$store.state?.CarriersStore?.carriers?.map((p: APICarrier) => {
                            return {
                                text: p.carrierName,
                                value: p.carrierId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getProvidersById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.ProvidersStore.providerForm
                    this.formData.carrierId = this.formData.carrierId.carrierId
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editProviders', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Providers'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createProviders', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Providers'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
